import React, { useEffect, useState } from "react";
import logo from "../../assets/images/le-logo.png";
import { useNavigate } from "react-router-dom";
import { API } from "../../helper/Api";
import { useRole } from "../contextApi/RoleContext";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OTPInput from "./OTPInput";
import { RotatingLines, ThreeDots } from "react-loader-spinner";
// import { useUser } from '../contextApi/SessionContext.js';

function Login() {
  const { setRole, role, setPermission, permission, setUserDetails } =
    useRole();
  const API_URL = process.env.REACT_APP_BASE_URL;
  // const { login } = useUser(); // Access the login function from context
  const [name, setName] = useState("");
  const [pwd, setPwd] = useState("");
  const [invalid, setInvalid] = useState("");
  const [errors, setErrors] = useState({
    name: "",
    pwd: "",
  });
  const [shakeName, setShakeName] = useState(false); // State for username shake
  const [shakePwd, setShakePwd] = useState(false); // State for password shake
  const [isOTP, setIsOTP] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Updated role@:", role);
  }, [role]); // This will log every time the role changes

  // Hide error message when user starts typing
  const handleNameChange = (e) => {
    setName(e.target.value);
    if (errors.name) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        name: "", // Clear the error for name
      }));
    }
  };

  const handlePwdChange = (e) => {
    const value = e.target.value;
    setPwd(value);

    // Define password validation regex
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

    let errorMessage = "";
    if (!passwordRegex.test(value)) {
      errorMessage =
        "Password must be at least 8 characters long, include a number, a special character, and an alphabet";
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      pwd: errorMessage,
    }));
  };

  const fetchPermission = async (id) => {
    try {
      const res = await API.accessSetting("getRolePermission", "");
      if (res.success) {
        console.log("check permission for current login user->", res);
        setPermission(res.content);
      } else {
        console.log("Error in fetching category");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const checkUser = async (e) => {
    e.preventDefault();
    setLoading(true);
    setInvalid("");
    // Validate the fields
    let formErrors = { name: "", pwd: "" };
    let isValid = true;

    // Username validation
    if (name.trim() === "") {
      formErrors.name = "Username is required";
      isValid = false;
      setShakeName(true); // Trigger shake effect for username
      setTimeout(() => setShakeName(false), 1000); // Reset shake effect after 1s
    }

    // Password validation
    if (pwd.trim() === "") {
      formErrors.pwd = "Password is required";
      isValid = false;
      setShakePwd(true); // Trigger shake effect for password
      setTimeout(() => setShakePwd(false), 1000); // Reset shake effect after 1s
    }

    // Set errors state
    setErrors(formErrors);

    if (isValid) {
      await fetch(`${API_URL}login.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
        body: JSON.stringify({
          username: name,
          password: pwd,
          type: "credentials",
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success === true) {
            Cookies.set("username", data.userName);
            Cookies.set("loginid", data.loginid);
            if (data.otp) {
              setLoading(false);
              setIsOTP(true);
              toast.info("An OTP has been sent to your email address..", {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
                className: "login-toast",
              });
            } else if (data.message.trim() === "redirect") {
              window.location.replace(data.portalLink);
            } else {
              setLoading(false);
              setRole(data.role_id); // Save role in context
              setUserDetails(data);
              fetchPermission(data.role_id);
              navigate("/");
            }
          } else {
            setLoading(false);
            if (data.message.trim() === "User not active") {
              toast.error(
                "Your account has been deactivated. Please contact the admin if you need assistance.",
                {
                  position: "top-center",
                  autoClose: false,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "colored",
                  className: "login-toast",
                }
              );
            } else {
              setInvalid("Invalid credentials");
              setShakeName(true); // Trigger shake animation for both fields
              setShakePwd(true);
              setTimeout(() => {
                setShakeName(false);
                setShakePwd(false);
              }, 1000); // Reset shake effect after 1s
            }
          }
        })
        .catch((error) => console.error("Error:", error));
    } else {
      setLoading(false);
    }
  };
  const handleOtpChange = async (otp) => {
    //  console.log("Entered OTP:", otp.length);
    if (otp.length === 6) {
      await fetch(`${API_URL}login.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
        body: JSON.stringify({
          username: name,
          password: pwd,
          otpVal: Number(otp),
          type: "otp",
          id: Cookies.get("loginid"),
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setRole(data.role_id); // Save role in context
            setUserDetails(data);
            fetchPermission(data.role_id);
            navigate("/");
          } else {
            // Cookies.remove("username");
            // Cookies.remove("loginid");
            toast.error("Invalid OTP. Please try again", {
              position: "top-center",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
              className: "login-toast",
            });
          }
        });
    }
  };
  // Input error styles
  const inputStyle = {
    // borderColor: 'red',
  };

  const invalidFeedbackStyle = {
    color: "red",
    fontSize: "12px",
  };

  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {/* Add the Shake Keyframe Animation */}
      <style>
        {`
          @keyframes shake {
            0% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            50% { transform: translateX(5px); }
            75% { transform: translateX(-5px); }
            100% { transform: translateX(0); }
          }

          .shake {
            animation: shake 0.5s ease-in-out;
          }
        `}
      </style>

      <div className="content" style={{ backgroundColor: "#f8fafb" }}>
        <div className="container" style={{ height: "100vh" }}>
          <div className="row justify-content-center p-4">
            <div className="col-md-6 contents">
              <div className="row justify-content-center">
                <div className="loginbody">
                  <div
                    className="form-block"
                    style={{ padding: isOTP ? "80px" : "60px" }}
                  >
                    <div className="mb-4" style={{ textAlign: "center" }}>
                      <img src={logo} alt="logo" className="img-fluid" />
                    </div>
                    {isOTP ? (
                      <div style={{ textAlign: "center" }}>
                        <label>Enter OTP Code</label>
                        <OTPInput length={6} onChange={handleOtpChange} />
                      </div>
                    ) : (
                      <form>
                        {invalid && (
                          <div
                            className="invalid"
                            style={{
                              color: "red",
                              fontSize: "16px",
                              marginTop: "10px",
                            }}
                          >
                            {invalid}
                          </div>
                        )}
                        <div
                          className={`form-group first ${
                            shakeName ? "shake" : ""
                          }`}
                        >
                          <input
                            type="text"
                            className={`form-control ${
                              errors.name ? "is-invalid" : ""
                            }`}
                            placeholder="Username"
                            name="name"
                            id="username"
                            required
                            onChange={handleNameChange}
                            style={errors.name ? inputStyle : {}}
                          />
                          {errors.name && (
                            <div
                              className="invalid-feedback"
                              style={invalidFeedbackStyle}
                            >
                              {errors.name}
                            </div>
                          )}
                        </div>
                        <div
                          className={`form-group last mb-4 ${
                            shakePwd ? "shake" : ""
                          }`}
                        >
                          <input
                            type="password"
                            className={`form-control ${
                              errors.pwd ? "is-invalid" : ""
                            }`}
                            placeholder="Password"
                            name="pwd"
                            id="password"
                            required
                            onChange={(e) => setPwd(e.target.value)}
                            style={errors.pwd ? inputStyle : {}}
                          />
                          {errors.pwd && (
                            <div
                              className="invalid-feedback"
                              style={invalidFeedbackStyle}
                            >
                              {errors.pwd}
                            </div>
                          )}
                        </div>

                        <div className="d-flex  align-items-center">
                          <span className="ml-auto">
                            <a href="forgotpassword" className="forgot-pass">
                              Forgot Password
                            </a>
                          </span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>

<ThreeDots
                          height="50" // Spinner height
                          width="50" // Spinner width
                          radius="9" // Border radius of dots
                          color="#36d7b7" // Spinner color
                          ariaLabel="loading"
                          visible={loading ? true : false} // Make it visible
                          
                        />
                          </div>
                        
                        <input
                          type="submit"
                          value="Log In"
                          onClick={checkUser}
                          className="btn btn-pill mt-3 text-white btn-block"
                        />
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
